import React, { useState, useEffect } from 'react';
import ReviewSlideshow from './ReviewSlideshow';
import { fetchCollection } from '../lib/cms';

const ReviewSection = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchCollection('testimonials').then(setTestimonials);
  }, []);

  if (testimonials.length === 0) return null;

  return (
    <section className="py-32 px-4 bg-stone-50 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-sm uppercase tracking-[0.4em] font-bold text-stone-700 mb-4">Anmeldelser</h2>
          <h3 className="!text-[1.6rem] md:text-6xl font-serif italic text-stone-900">Det siger kunderne</h3>
        </div>
        
        <ReviewSlideshow reviews={testimonials} />
      </div>
    </section>
  );
};

export default ReviewSection;
